































import { Vue, Component, Prop } from 'vue-property-decorator';

import Icon from "../../../../components/Icon/Icon.vue";
import { VueComponent } from "../../../../shared/types/VueComponent";
import getAnyValue from "../../../../shared/utils/getAnyValue";
import TemplateContext from "../../includes/TemplateContext";
import { ConfigMenuItem, MenuItemType } from "../../includes/types/MenuItem";

@Component({
  components: {
    Icon
  }
})
export default class FeedbackExtraItems extends Vue {
  @Prop() extraItems!: Array<Record<'menuItem', ConfigMenuItem>>

  templateContext = new TemplateContext(this.$route)

  isCustomComponentModalOpen = false

  selectedCustomComponent: VueComponent | null = null

  async selectItem(item: ConfigMenuItem) {
    if (item.type === MenuItemType.DropDownLink) {
      const url = await getAnyValue(item.url, this.templateContext)

      window.open(url, '_blank')
    } else if ((item.type === MenuItemType.DropDownLinkComponent && item.component) || item.type === MenuItemType.Component && item.component) {
      this.selectedCustomComponent = item.component
      this.isCustomComponentModalOpen = true
    }
  }

}
